import React from 'react'

import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'

import {H3, H4} from '@festi/common/components/typography'
import {formatPercentage, formatPrice} from '@festi/utils/numbers'
import {formatRestDate} from '@festi/common/utils/dates'
import {styledTheme} from '@festi/common/themes'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;

  ${media.md`
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const Table = styled.div`
  display: grid;
  width: 100%;
  border-collapse: collapse;
`

export const Start = styled.div`
  justify-self: start;
  display: flex;
  flex-direction: row;
`
export const End = styled.div`
  justify-self: end;
`

export const Row = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${styledTheme.palette.grey};
`

export const Disclaimer = styled.p`
  font-size: 12px;
  color: ${styledTheme.palette.grey};
`

// TODO: This component needs refactoring and adjustments according to design - this
// code is just copied from old PagoBNPLWidget component - it's not used anywhere yet
export default function PagoPayLaterOption() {
  const PAYMENT_FEE = Number(495)

  const amount = 123456
  const APR = Number(0.4312)
  const numberOfDays = 14

  const paymentDate = new Date()
  paymentDate.setDate(paymentDate.getDate() + numberOfDays)
  const loanFeeAmount = Number(amount) * 0.0175
  return (
    <Root>
      <Header>
        <H3 center>
          Gjalddagi eftir <strong>{numberOfDays}</strong> daga
        </H3>
      </Header>

      <Table>
        <Row>
          <Start>Verð</Start>
          <End>{formatPrice(amount)}</End>
        </Row>
        <Row>
          <Start>Lántökugjald</Start>
          <End>{formatPrice(Number(amount) * 0.0175)}</End>
        </Row>

        <Row>
          <Start>Greiðslugjald</Start>
          <End>{formatPrice(PAYMENT_FEE)}</End>
        </Row>

        <Row>
          <Start>ÁHK</Start>
          <End>{formatPercentage(APR)}%</End>
        </Row>
        <Row>
          <Start>Greiðist þann:</Start>
          <End>{formatRestDate(paymentDate.toDateString())}</End>
        </Row>
        <Row>
          <Start>
            <H4>Heildarverð</H4>
          </Start>
          <End>
            <H4>
              {formatPrice(
                Number(amount) + Number(loanFeeAmount) + Number(PAYMENT_FEE),
              )}
            </H4>
          </End>
        </Row>
      </Table>
      <Disclaimer>Kaup eru staðfest með rafrænum skilríkjum.</Disclaimer>
    </Root>
  )
}
